module.exports = __webpack_public_path__ + "static/media/styles.b2328beb.scss";


//////////////////
// WEBPACK FOOTER
// ./src/sass/styles.scss
// module id = 230
// module chunks = 0